import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'do_wrkrs_have_access_to_external_contacts_outside_of_mgmt_that'

export const dataPointDefinition = {
  retracedId: 'do_wrkrs_have_access_to_external_contacts_outside_of_mgmt_that',
  name: 'Do workers have access to external contacts outside of management that aid in resolving complaints, grievances, harassment or abuse cases?',
  description:
    'The intent of this question is to understand if there are people or groups outside of management that assist in resolving complaints, grievances, harassment or abuse cases. This is not about workers being able to freely contact an external entity if they wish, but rather that the grievance mechanism in place specifically includes or facilitates the inclusion of these external individuals or organizations.\r\r\n\r\r\nExternal individuals or organizations include consideration for all types of workers including women, migrants, and other marginalized workers.\r\r\n\r\r\nExample of such persons or groups might include: Non-government organizations (NGOs), Women’s groups, Health clinics, Respected community member(s), Local brand representatives, Union representatives, Worker representatives, etc. ',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'gr-2',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12960,
  sectionId: '2.2.10',
  impactArea: 'Social Dialogue, Grievance Mechanisms and Disputes',
  impactAreaId: 'COMPLAINT_AND_GRIEVANCE_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
